import './log-viewer.css';
export default {
    "logViewer": "pf-v6-c-log-viewer",
    "logViewerHeader": "pf-v6-c-log-viewer__header",
    "logViewerIndex": "pf-v6-c-log-viewer__index",
    "logViewerList": "pf-v6-c-log-viewer__list",
    "logViewerListItem": "pf-v6-c-log-viewer__list-item",
    "logViewerMain": "pf-v6-c-log-viewer__main",
    "logViewerScrollContainer": "pf-v6-c-log-viewer__scroll-container",
    "logViewerString": "pf-v6-c-log-viewer__string",
    "logViewerText": "pf-v6-c-log-viewer__text",
    "logViewerTimestamp": "pf-v6-c-log-viewer__timestamp",
    "modifiers": {
        "dark": "pf-m-dark",
        "wrapText": "pf-m-wrap-text",
        "nowrap": "pf-m-nowrap",
        "lineNumbers": "pf-m-line-numbers",
        "lineNumberChars": "pf-m-line-number-chars",
        "match": "pf-m-match",
        "current": "pf-m-current"
    },
    "themeDark": "pf-v6-theme-dark",
    "toolbar": "pf-v6-c-toolbar",
    "toolbarContentSection": "pf-v6-c-toolbar__content-section"
};
//# sourceMappingURL=log-viewer.js.map